const ITEMS = [
  "More reviews",
  "Less friction",
  "One tap",
  "No app",
  "No subscription",
  "Ready to use",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="px-8 font-display text-4xl font-medium tracking-tight text-ink/85 sm:text-5xl md:text-6xl">
          {t}
        </span>
        <span className="text-2xl text-ink/25">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section
    className="border-y border-line bg-sand py-8 md:py-10"
    aria-hidden="true"
    data-testid="marquee-section"
  >
    <div className="relative flex overflow-hidden">
      <div className="flex animate-marquee whitespace-nowrap will-change-transform">
        <Row />
        <Row />
      </div>
    </div>
  </section>
);
